import styled, { css } from 'styled-components';

export const ScreenStyled = styled.div<{ width?: 'default' | 'large' }>`
  box-sizing: border-box;
  padding: 8px;
  ${({ width = 'default' }) => {
    switch (width) {
      case 'default': {
        return css`
          width: 244px;
        `;
      }
      case 'large': {
        return css`
          width: 416px;
        `;
      }
      default: {
        return css`
          width: initial;
        `;
      }
    }
  }}
`;

export const HeaderWrapperStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ActionsWrapperStyled = styled.div<{
  justifyContent?: 'start' | 'center' | 'end';
}>`
  margin-top: 8px;
  display: flex;
  ${({ justifyContent = 'start' }) =>
    css`
      justify-content: ${justifyContent};
    `}
`;

export const FeedbackInputWrapperStyled = styled.div`
  margin-top: 16px;
`;
